const scrollFromTop = (pxFromTop: number) => {
  window.scrollTo({ top: pxFromTop, behavior: 'smooth' }); // here it goes
};

export { scrollFromTop };
